window.I18n = require('i18n-js');

require('../translations/en.js');
require('../translations/accepted_payment_methods/en.js');
require('../translations/category_select/en.js');
require('../translations/comparison_shopping_page/en.js');
require('../translations/countries/en.js');
require('../translations/currencies/en.js');
require('../translations/digital_listings/en.js');
require('../translations/email_offers/en.js');
require('../translations/listing_form/en.js');
require('../translations/price_guide/en.js');
require('../translations/product_show_page/en.js');
require('../translations/shipping_rates/en.js');
require('../translations/shop_stats/en.js');
require('../translations/zendesk/en.js');

// Global config
window.I18n.fallbacks = true;
window.I18n.locales.eo = []; // Translator's Locale



// WEBPACK FOOTER //
// ./javascripts/components/translations.js